/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import ObjectType from './ObjectType';
import MoserObject from './MoserObject';
import UsageType from './UsageType';
import RegularAggregateType from './RegularAggregateType';
import HighLevelDataType from './HighLevelDataType';
//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper
//@import com/ibm/bi/platform/moser/common/generated/metadata/UsageType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/RegularAggregateType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/HighLevelDataType (runtime) // new

/**
 * <p>Java class for projectedItemType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="projectedItemType"&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="externalName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="usage" type="{}usageType" minOccurs="0"/&gt; &lt;element name="datatype" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="nullable" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="regularAggregate" type="{}regularAggregateType" minOccurs="0"/&gt; &lt;element name="highlevelDatatype" type="{}highLevelDataType" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class ProjectedItemType extends ObjectType{

	externalName = null;

	usage = null;

	datatype = null;

	nullable = null;

	regularAggregate = null;

	highlevelDatatype = null;



	/**
	 * Gets the value of the externalName property.
	 * @return {String} possible object is {@link String}
	 */
	getExternalName() {
		return this.externalName;
	}

	/**
	 * Sets the value of the externalName property.
	 * @param {String} value allowed object is {@link String}
	 */
	setExternalName(value) {
		var oldValue = this.externalName;
		this.externalName = value;
		this._setAndNotify(76, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the usage property.
	 * @return {UsageType} possible object is {@link UsageType}
	 */
	getUsage() {
		return this.usage;
	}

	/**
	 * Sets the value of the usage property.
	 * @param {UsageType} value allowed object is {@link UsageType}
	 */
	setUsage(value) {
		var oldValue = this.usage;
		this.usage = value;
		this._setAndNotify(77, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the datatype property.
	 * @return {String} possible object is {@link String}
	 */
	getDatatype() {
		return this.datatype;
	}

	/**
	 * Sets the value of the datatype property.
	 * @param {String} value allowed object is {@link String}
	 */
	setDatatype(value) {
		var oldValue = this.datatype;
		this.datatype = value;
		this._setAndNotify(64, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the nullable property.
	 * @return {Boolean} possible object is {@link Boolean}
	 */
	isNullable() {
		return this.nullable;
	}

	/**
	 * Sets the value of the nullable property.
	 * @param {Boolean} value allowed object is {@link Boolean}
	 */
	setNullable(value) {
		var oldValue = this.nullable;
		this.nullable = value;
		this._setAndNotify(74, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the regularAggregate property.
	 * @return {RegularAggregateType} possible object is {@link RegularAggregateType}
	 */
	getRegularAggregate() {
		return this.regularAggregate;
	}

	/**
	 * Sets the value of the regularAggregate property.
	 * @param {RegularAggregateType} value allowed object is {@link RegularAggregateType}
	 */
	setRegularAggregate(value) {
		var oldValue = this.regularAggregate;
		this.regularAggregate = value;
		this._setAndNotify(78, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the highlevelDatatype property.
	 * @return {HighLevelDataType} possible object is {@link HighLevelDataType}
	 */
	getHighlevelDatatype() {
		return this.highlevelDatatype;
	}

	/**
	 * Sets the value of the highlevelDatatype property.
	 * @param {HighLevelDataType} value allowed object is {@link HighLevelDataType}
	 */
	setHighlevelDatatype(value) {
		var oldValue = this.highlevelDatatype;
		this.highlevelDatatype = value;
		this._setAndNotify(75, oldValue, value, false, true);
	}

	/**
	 * Creates a new instance of <code>ProjectedItemType</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> ProjectedItemType</code> object from.
	 * @return {ProjectedItemType} an object of type <code>ProjectedItemType</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createProjectedItemType();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "ProjectedItemType";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 76, "externalName", null));
		featureList.push(this.createFeature(false, true, false, 77, "usage", UsageType));
		featureList.push(this.createFeature(false, false, false, 64, "datatype", null));
		featureList.push(this.createFeature(false, false, false, 74, "nullable", null));
		featureList.push(this.createFeature(false, true, false, 78, "regularAggregate", RegularAggregateType));
		featureList.push(this.createFeature(false, true, false, 75, "highlevelDatatype", HighLevelDataType));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 74:
			this.setNullable((value));
			break;
		case 64:
			this.setDatatype((value));
			break;
		case 75:
			this.setHighlevelDatatype((value));
			break;
		case 76:
			this.setExternalName((value));
			break;
		case 77:
			this.setUsage((value));
			break;
		case 78:
			this.setRegularAggregate((value));
			break;
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 74:
			return this.isNullable();
		case 64:
			return this.getDatatype();
		case 75:
			return this.getHighlevelDatatype();
		case 76:
			return this.getExternalName();
		case 77:
			return this.getUsage();
		case 78:
			return this.getRegularAggregate();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 74:
			return this.isNullable();
		case 64:
			return this.getDatatype();
		case 75:
			return this.getHighlevelDatatype();
		case 76:
			return this.getExternalName();
		case 77:
			return this.getUsage();
		case 78:
			return this.getRegularAggregate();
		default:
			return super.basicGet(featureID);
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/ProjectedItemType.js